<template>
	<v-layout
		row wrap align-center
		justify-center
		newprimary
		class="category-tag"
	>
		<img
			:src="category.icon"
			:alt="`categoría ${category.name}`"
			height="25"
			class="category-tag-icon"
		/>
		<span class="white--text fs-16 w-black">{{ category.name }}</span>
	</v-layout>
</template>

<script>
	export default {
		name: 'category-tag',
		props: {
			category: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.category-tag {
		border-bottom-right-radius: 50px;
		border-top-right-radius: 50px;
		height: 50px;
		min-width: 164px;
		padding: 0 21px;
		width: fit-content;
		width: -moz-fit-content;

		&-icon {
			filter: brightness(0) invert(1);
			margin-right: 5px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/category-tag.vue